import { OnBeforeRouteSync } from 'vike/types';
import { redirect } from 'vike/abort';
import { extractLocale } from '../utils/extractLocale';
import redirects from './redirects';

export const onBeforeRoute: OnBeforeRouteSync = (pageContext): ReturnType<OnBeforeRouteSync> => {
  const { urlPathname } = pageContext;
  if (urlPathname === '/') {
    throw redirect('https://www.venuepilot.com');
  }

  const foundRedirect = redirects[urlPathname];
  if (foundRedirect) {
    throw redirect(foundRedirect, 301);
  }

  const url = pageContext.urlParsed;

  const { locale } = extractLocale(url.search);

  return {
    pageContext: {
      locale,
    },
  };
};
